(function () {
  angular
    .module('kareo.ui.shared.modules.authentication.k-roles', [])
    .constant('K_ROLES', {
      ADMIN: 1,
      PROVIDER: 2,
      PHYSICIAN_ASSISTANT: 3,
      CLINICAL_ASSISTANT: 4,
      OFFICE_STAFF: 5,
      BILLER: 6,
      BUSINESS_MANAGER: 7
    });
})();